import React from 'react';
import styles from './ListCard.module.css';

const ListCard = ({ heading, text, image }) => {
  return (
    <div className={styles.container}>
      <img src={image} alt="" className={styles.image} />
      <div className={styles.textContainer}>
        <h2 className={styles.heading}>{heading}</h2>
        <p className={styles.text}>{text}</p>
      </div>
    </div>
  );
};

export default ListCard;
